import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { apiClient, type Venue } from '@api';
import { QueryKeys } from '@config';

/**
 * Retrieves a single venue by slug/identifier.
 *
 * Required params: venue slug from route or context.
 * Important behavior: query is disabled until slug is truthy; accepts custom React Query options.
 *
 * @example
 * const { data: venue, isPending } = useGetVenue(venueSlug);
 */
export const useGetVenue = (
  slug: string,
  options: Omit<UseQueryOptions<Venue | undefined>, 'queryKey' | 'queryFn'> = {}
) => {
  return useQuery<Venue | undefined>({
    queryKey: [QueryKeys.VENUES, slug],
    queryFn: async () => {
      const response = await apiClient.venuesRetrieve({
        path: { identifier: slug },
      });
      return response.data;
    },
    enabled: !!slug,
    ...options,
  });
};
